// extracted by mini-css-extract-plugin
module.exports = {"designersGrid":"designers-main_designersGrid__sx8PR"};